import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=e9bfcbca&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=e9bfcbca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bfcbca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9bfcbca')) {
      api.createRecord('e9bfcbca', component.options)
    } else {
      api.reload('e9bfcbca', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=e9bfcbca&scoped=true", function () {
      api.rerender('e9bfcbca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/upload.vue"
export default component.exports